import { Component, Input, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, ModalController } from 'ionic-angular';
import { ProductosElaboradosProvider } from '../../providers/productos-elaborados/productos-elaborados'
import { ProductosElaboradosContenidoDetallePage } from '../../pages/productos-elaborados-contenido-detalle/productos-elaborados-contenido-detalle'
import { productosElaboradosModelo }  from '../../models/productosElaborados'
import { ProductosElaboradosContenidoProvider } from '../../providers/productos-elaborados-contenido/productos-elaborados-contenido'
import { Storage } from '@ionic/storage'
import { DesperdiciosProvider } from '../../providers/desperdicios/desperdicios'
import { desperdiciosDiarios } from '../../models/desperdiciosDiarios'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { NUBE_AWS } from '../../config/url.servicio';

@IonicPage()
@Component({
  selector: 'page-desperdicios',
  templateUrl: 'desperdicios.html',
  providers: [ AuthService ]
})
export class DesperdiciosPage {
  data: any;
  events: any;
  buscar: any = "";
  buscarProducto: any ="";
  allItems: any;
  productosElaborados = []
  productosElaboradosContenido = []
  productosParaDesperdiciosDiarios:desperdiciosDiarios[] = []
  busquedaSimpleMostrar :productosElaboradosModelo = {}
  busquedaContenidoMostrar :productosElaboradosModelo = {}
  productosElaboradosId: any
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId:any = null
  public datos:productosElaboradosModelo = {}


  constructor(public navCtrl: NavController, public navParams: NavParams,
              public toastControllers:ToastController,
              public servicioProductosElaborados:ProductosElaboradosProvider,
              public modalControllers: ModalController,
              public servicioProductoselaboradosContenido:ProductosElaboradosContenidoProvider,
              public storage:Storage,
              public servicioDesperdiciosProvider:DesperdiciosProvider,
              public servicioCompania:CompaniasProvider,
              public auth: AuthService
            ) {
this.cargarTodo()
}

cargarTodo(){
  this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
  .then((val)=>{
    if(val){
      this.nombreCompaniaHeader = val['nombreCompania']
      this.nombreCargoHeader = val['nombreCargo']
      this.companiasId = val['companiasId']
      this.productosParaDesperdiciosDiarios = []
      
      this.servicioDesperdiciosProvider.productosParaDesperdiciosDiariosCompania(this.companiasId)
      .subscribe( 
        (data) => {
          let valor
          let datos
          if(NUBE_AWS){
            valor = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data
            datos = valor[0]
          } else {
            valor = data['_body']
            datos = JSON.parse(valor)
          }
          this.productosParaDesperdiciosDiarios = NUBE_AWS ? datos : datos[0]
          },
        err => {
            this.mensajeToast('No se pudieron listar los productosElaborados, intente luego')
        }
      )

    }
  })
  this.cargarProductos()
}

cerrarSession(){
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}

  cargarProductos() {
    this.productosParaDesperdiciosDiarios = []

    this.servicioDesperdiciosProvider.productosParaDesperdiciosDiariosCompania(this.companiasId)
    .subscribe( 
      (data) => {
        let valor
        let datos
        if(NUBE_AWS){
          valor = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data
          datos = valor[0]
        } else {
          valor = data['_body']
          datos = JSON.parse(valor)
        }
        this.productosParaDesperdiciosDiarios = NUBE_AWS ? datos : datos[0]
        },
      err => {
          this.mensajeToast('No se pudieron listar los productosElaborados, intente luego')
      }
    )
  } 

  Detalle(datos:productosElaboradosModelo) {
    if(datos){
      this.datos = datos
      this.productosElaboradosId = this.datos['productosElaboradosId']

      this.cargarProductosElaboradosContenidos(this.datos)
    }
  }

  disminuirUnProductoElaborado(item, index) {
    let cantidadactual = item['cantidad']
    let descontar = 1
    let nuevaCantidad = 0
    nuevaCantidad = cantidadactual - descontar
    let valornuevo =JSON.stringify(nuevaCantidad)
    let valor = valornuevo.split('.');
    let sacarValor = 0
    let valorReal = ""
    let valorReales = 0
    let valorInicial = 0
    for(var i=0; i < valor.length;i++){
      if(i==valor.length -1){
        sacarValor = valor[i].length
        if(sacarValor>2){
          valorReal = valor[i]
          valorReal = valorReal.substr(0,1) 
          valorReales = Number(valorReal) + 1
          sacarValor = Number(valorReales)
          let valores = ""
          valores = `${valorInicial}.${sacarValor}` 
          nuevaCantidad = Number(valores) 
        }

      }else{
        valorInicial = Number(valor[i])
      }
    }

    

    
    if(nuevaCantidad <= 0){
      this.productosElaboradosContenido[index]['cantidad'] = 0
    }else{
        this.productosElaboradosContenido[index]['cantidad'] = nuevaCantidad
  }
}

aumentarUnProductoElaborado(item, index) {
    let nuevaCantidad = Number(item['cantidad']) + 1
    this.productosElaboradosContenido[index]['cantidad'] = nuevaCantidad

}
mymodel:number
mymodelSimple:number
cantidadActual:number
cantidad:number
nuevacantidad:number 
search(cantidadafn:any,item,index){
   setTimeout(() => {
      if(Number(cantidadafn['_value'])==0){
        return
      }
      let cantidadactual = Number(item['cantidad'])
      let cantidad = Number(cantidadafn['_value'])
      let nuevacantidad = cantidadactual +  cantidad 
      this.cantidadActual = cantidadactual
      this.cantidad = cantidad
      this.nuevacantidad = nuevacantidad 
      this.productosElaboradosContenido[index]['cantidad'] =  this.nuevacantidad
      cantidadafn['_value'] = 0
      this.mymodel = null
    },1000)
  }


disminuirUnProductoSimple(item, index) {
  let nuevaCantidad = Number(item['cantidad']) - 1

  let valornuevo =JSON.stringify(nuevaCantidad)
  let valor = valornuevo.split('.');
  let sacarValor = 0
  let valorReal = ""
  let valorReales = 0
  let valorInicial = 0
  for(var i=0; i < valor.length;i++){
    if(i==valor.length -1){
      sacarValor = valor[i].length
      if(sacarValor>2){
        valorReal = valor[i]
        valorReal = valorReal.substr(0,1) 
        valorReales = Number(valorReal) + 1
        sacarValor = Number(valorReales)
        let valores = ""
        valores = `${valorInicial}.${sacarValor}` 
        nuevaCantidad = Number(valores) 
      }

    }else{
      valorInicial = Number(valor[i])
    }
  }
 
  if(nuevaCantidad <= 0){
    this.productosParaDesperdiciosDiarios[index]['cantidad'] = 0
  }else{
      this.productosParaDesperdiciosDiarios[index]['cantidad'] = nuevaCantidad
}
}


aumentarUnProductoSimple(item, index) {
  let nuevaCantidad = Number(item['cantidad']) + 1
  this.productosParaDesperdiciosDiarios[index]['cantidad'] = nuevaCantidad
}


cargarProductosElaboradosContenidos(datos:any) {
  this.productosElaboradosContenido = []
  this.productosParaDesperdiciosDiarios = []

  this.storage.get('companiasId').then((val) => {
    let valores = []
    valores['companiasId'] = val
    valores['id'] = Number(datos.productosElaboradosId) 
    this.servicioProductoselaboradosContenido.buscar(valores)
    .subscribe( 
      data => {
        let valor
        let datos
        if(NUBE_AWS){
          valor = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data
          datos = valor[0]
        } else {
          valor = data['_body']
          datos = JSON.parse(valor)
        }
        this.productosParaDesperdiciosDiarios = NUBE_AWS ? datos : datos[0]
      },
      err => {
      this.mensajeToast('No se pudieron traer los datos, intente luego')
      }  
    )     
  })
}

  ionViewDidLoad() {
  
  }

  getItems(event: any): void {
          if(!this.allItems){
            let valores = this.productosParaDesperdiciosDiarios
            this.allItems = valores;
          } 
            this.productosParaDesperdiciosDiarios = this.allItems.filter((item) => {
              return item.nombreProducto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
            });
 }

  onEvent(event: string, item: any){ 
 
    if (event === 'onTextChange') {
       
       let valor = this.getItems(this.buscar);
       if(valor){
            item = valor
      } 
  }
}
  mensajeToast(mensaje: string) {
    let item =    {
        "duration": 1000,
        "position": "buttom"
      }
      item["message"] = mensaje;
    let toast = this.toastControllers.create(item);
    toast.present();
  }  


  guardar() {

    this.storage.get('usuariosId').then((val)=>{
      let valores = []
      
       for(var i=0;i<this.productosParaDesperdiciosDiarios.length;i++){
        if(this.productosParaDesperdiciosDiarios[i]['cantidad']>0){
          valores.push({
            productosId:this.productosParaDesperdiciosDiarios[i]['productosId'], 
            cantidad:this.productosParaDesperdiciosDiarios[i]['cantidad'],
            valorVenta:this.productosParaDesperdiciosDiarios[i]['valorVenta'],
            usuariosId:val
          })
        }
       }
    
      let usuariosId = val
      if(valores.length<=0){
        this.mensajeToast('debe ingresar algún producto')
        return false
      }
      this.servicioDesperdiciosProvider.guardarDesperdicios(valores)
      .subscribe(
      res => {
        this.limpiar()
        this.cargarTodo()
        this.mensajeToast('registro guardado con exito')
      },
      err => this.mensajeToast(err + ' Error al guardar con exito...')
      )


   })
  }
limpiar(){
  this.productosElaborados = []
  this.productosElaboradosContenido = []
  this.productosParaDesperdiciosDiarios = []
}
}



// WEBPACK FOOTER //
// ./src/pages/desperdicios/desperdicios.ts